/* NotFound.js */

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function NotFound() {
  return (
    <div className='pb-bg-1'>
    <Container>
      <Row className='login-page justify-content-center align-items-center'>
        <Col md={6}>
          <Card className='p-2 shadow text-center'>
            <CardBody>
              <div className='mb-4'>
                <h1 className="h2 modal-title">{Strings('application_title')}</h1>
              </div>
              
              <div className='mb-4'>
                <h2 className="h4 opacity-8">{Strings('page_not_found')}</h2>
              </div>

              <div className='mb-5'>
                <Link to="/" className="btn btn-primary pb-btn-1 btn-shadow">
                  {Strings('go_home')}
                </Link>
              </div>

              <div className="opacity-8">
                Copyright &copy; Photozig Inc.
              </div>
            </CardBody>
            
          </Card>
        </Col>
      </Row>
    </Container>
  </div>
  );
}
